import { render, staticRenderFns } from "./show.lists.page.vue?vue&type=template&id=35d71993&scoped=true&"
import script from "./show.lists.page.vue?vue&type=script&lang=js&"
export * from "./show.lists.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d71993",
  null
  
)

export default component.exports